import config from 'config';
import { split } from 'apollo-link';
import { ApolloClient } from 'apollo-client';
import { WebSocketLink } from 'apollo-link-ws';
import { setContext } from 'apollo-link-context';
import { createUploadLink } from 'apollo-upload-client';
import { getMainDefinition } from 'apollo-utilities';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { getWSClient } from 'modules/websocket/WSManager';

const uri = `${ config.api_server }?useGraphqlUpload`;

const wsLink = new WebSocketLink(getWSClient());

const authLink = setContext(() => (Object.freeze({
  headers: { authentication: localStorage.getItem('jwt') ? `Bearer ${ localStorage.getItem('jwt') }` : null },
})));

const httpLink = authLink.concat(createUploadLink({ uri }));

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);

export default new ApolloClient({
  link,
  cache: new InMemoryCache(),
});
